import { ProjectModel } from 'api-hooks/projects';

export default function defaultValueProject(data: ProjectModel) {
  return {
    id: data.id,
    code: data.code,
    name: data.name,
    description: data.description,
    projectCustomers: (data.projectCustomers || []).map((item) => ({
      id: item.customer.id,
      customerId: item.customer.id,
      label: `${item.customer.name} ${item.customer.alias}`,
    })),
    projectGuests: (data.projectGuests || []).map((item) => ({
      id: item.guest.id,
      guestId: item.guest.id,
      label: `${item.guest.title} ${item.guest.name}`,
    })),
    projectItineraries: (data.projectItineraries || []).map((item) => ({
      id: item.id,
      date: item.date,
      description: item.description,
      route: item.route,
      isComplete: item.isComplete,
    })),
  };
}
